// extracted by mini-css-extract-plugin
export default {"MetricsView":"MetricsView1XyOL3zE7X1O","MetricsView_with-bottom-bar":"MetricsView_with-bottom-bar1qtZ6EJ6KF3D"};